import React from 'react';
import MessageLogs from './message/index';

const Dashboard = () => {
	return <MessageLogs />;
}

export default Dashboard